import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { Grid, Stepper, Step, StepLabel, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import GeneralSettings from '../../components/settings/general';
import VisualSettings from '../../components/settings/visual';
import CampusSettings from '../../components/settings/campus';
import Mailing from '../../components/settings/mailing';
import { newUpdatePlatform } from '../../redux/actions/_initializer_actions';
import { ShowNotification } from '../../components/Notifications';
import { palette } from '../../system/styles/styles';
// TODO: Parece que Help desaparecio del diseño
// import HelpSection from './components/HelpSection';
const MainContainer = styled.main`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-family: 'Sofia Pro', sans-serif;
  .button {
    margin-top: 16px;
    margin-right: 16px;
  }
  .actionsContainer {
    margin-bottom: 16px;
  }
  .resetContainer {
    padding: 16px;
  }
  .listContainer {
    width: 100%;
    margin: 20px auto;
    height: 75vh;
    overflow: auto;
  }
  .leftStepper {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    height: 100%;
    justify-content: flex-start;
    align-items: flex-start;

    .stepperTitle {
      font-size: 2rem;
      font-family: 'Cooper Md BT', sans-serif;
      font-weight: 500;
      line-height: 32px;
      padding: 0px;
      align-self: center;
    }
  }
  .mainContainer {
    height: 100vh;
    overflow: auto;
  }
  .stepImage {
    height: 100px;
    display: flex;
    margin: 20px 0px 20px 24%;
  }
  .stepper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 24%;
    width: 85%;
  }
  .step {
    display: flex;
    width: 100%;
    align-items: center;
  }
  .inputRadio {
    color: #5373fc;
    background-color: #5373fc;
    transform: scale(1.7);
    width: 30px;
    margin: 0px !important;
    cursor: pointer;
  }
  .stepConector {
    width: 2px;
    border-left: solid 3px #aeaec1;
    height: 32px;
    margin: 4px 0px;
  }
  .stepLabel {
    font-size: 1.2rem !important;
    color: #aeaec1;
    line-height: 32px;
    margin: 0px;
    margin-left: 12px;
    font-weight: 500;
    cursor: pointer;
  }
  .generalSettingsContainer {
    width: 100%;
    padding: 50px 50px 50px 0px;
  }
  .visualSettingsContainer {
    display: grid;
    grid-template-columns: 1fr 64px;
    grid-gap: 8px;
  }
  .previewContainer {
    width: 92%;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: ${palette.white};
    border-radius: 8px;
    box-shadow: 0px 2px 30px #00000029;
  }
  .editorArea {
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-radius: 8px;
  }
  .formSettingsPage {
    width: 100%;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .notificationSettings {
    width: 100%;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .generalSettingsNavBar {
    width: 100%;
    display: flex;
    padding: 10px 16px;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: ${palette.white};
    box-shadow: 0px 2px 30px #00000029;
    border-radius: 8px;
  }
  .navItem {
    width: 33.33%;
    padding: 11px 0px;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 32px;
    color: ${palette.black};
    text-align: center;
    margin: 0px;
    cursor: pointer;
  }
  .navItemActive {
    width: 33.33%;
    padding: 11px 0px;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    margin: 0px;
    background-color: rgba(83, 115, 252, 0.2);
    color: #5373fc;
    cursor: pointer;
    border-radius: 8px;
  }
  .generalSettingsPage {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
  }
  .configCard {
    width: 100%;
    padding: 24px 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-shadow: 0px 2px 30px #00000029;
    background-color: ${palette.white};
    margin-top: 40px;
    border-radius: 8px;
  }
  .configCardTitleCont {
    width: 100%;
    padding: 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 40px;
  }
  .configCardTitle {
    font-size: 1.4rem;
    line-height: 32px;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: 0;
    margin-right: 32px;
    min-width: calc(16% - 32px);
    font-weight: 500;
  }
  .dividerHorizontal {
    height: 20px;
    width: 10px;
    border-right: solid 3px #eeeeee;
  }
  .configCardDesc {
    margin: 0;
    border-left: solid 2px #f0f1f8;
    padding: 10px 0px 10px 40px;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 24px;
    color: #6a6a80;
  }
  .configCardDescItem {
    margin: 0;
    border-left: solid 2px #e0e0e6;
    padding: 14px 0 14px 30px;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 32px;
    color: #232323;
  }
  .mailBodyContainer {
    width: 100%;
    //height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: auto;
    position: relative;
  }
  .labelsConfigCont {
    width: 100%;
    display: flex;
    padding: 0;
  }
  .labelConfigR {
    font-size: 1.2rem;
    color: #aeaec1;
    font-weight: 500;
    line-height: 32px;
    width: 17%;
    text-align: start;
    margin: 0;
  }
  .labelConfigL {
    font-size: 1.2rem;
    color: #aeaec1;
    font-weight: 500;
    line-height: 32px;
    width: calc(16% + 40px);
    text-align: start;
    margin: 0;
  }
  .labelConfigLForm {
    font-size: 1.3rem;
    color: #aeaec1;
    width: calc(16% + 40px);
    text-align: start;
    margin: 0;
  }
  .configCampusSelection {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 32px;
  }
  .configCardSelection {
    min-height: 88px;
    width: 100%;
    border: solid 2px #f0f1f8;
    display: flex;
    margin-bottom: 16px;
    align-items: center;
    border-radius: 4px;
  }
  .configCardSelection2 {
    min-height: 88px;
    width: 100%;
    border: solid 2px #f0f1f8;
    display: flex;
    margin-bottom: 16px;
    align-items: center;
    justify-content: space-between;
    border-radius: 4px;
    padding: 0px 24px;
  }
  .labelTypeUser {
    padding: 10px;
    width: 20%;
    border-right: solid 2px #f0f1f8;
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 1.2rem !important;
    color: #232323;
    line-height: 32px;
  }
  .selectionArea {
    width: 12%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .selectionAreaForm {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: solid 1px #ffe6e6ee;
  }
  .checkBox {
    transform: scale(3);
    color: #5373fc;
    margin: 0 !important;
    width: auto;
  }
  .selectComponent {
    color: #5373fc;
    margin: 0 !important;
    width: auto;
    padding: 0;
    font-size: 1.2rem !important;
    border: none;
  }
  .inputText {
    width: 100%;
    background-color: #eeeeee;
    border: none !important;
    padding: 12px 8px !important;
    font-size: 1.2rem !important;
    color: ${palette.black};
    border-radius: 8px;
  }
  .inputTextEmpty {
    width: 47.5%;
    background-color: #eeeeee;
    border: none !important;
    padding: 12px 8px !important;
    font-size: 1.2rem !important;
    color: ${palette.black};
    border-radius: 8px;
  }
  .questionContainer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0px 50px;
  }
  .saveQuestion {
    padding: 7px 20px;
    background-color: #5373fc;
    font-size: 1.3rem !important;
    border-radius: 5px;
    color: ${palette.white};
    height: auto;
    min-width: 173px;
  }
  .formSettingsTitle {
    font-size: 1.2rem;
    color: #aeaec1;
    width: 100%;
    text-align: start;
    margin-bottom: 10px;
  }
  .navBarPreview {
    width: 100%;
    height: 70px;
    position: relative;
    display: flex;
    background-color: ${palette.white};
    border-radius: 8px 8px 0px 0px;
  }
  .navBarLogoContainer {
    width: 80px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: auto 10px;
    height: 100%;
  }
  .leftMenu {
    display: flex;
    margin: auto 10px;
    justify-content: space-around;
    align-items: center;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .leftMenuLink {
    font-size: 1.4rem;
    font-weight: 600;
    padding: 0px;
    cursor: pointer;
    margin: auto 15px;
  }
  .rightMenu {
    display: flex;
    margin: auto 25px 25px auto;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .mainImage {
    width: 100%;
    padding: 0px;
    height: 70vh;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .shapeContainer {
    width: 60%;
    height: 75vh;
    clip-path: polygon(0 0, 65% 0, 100% 100%, 35% 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    @media screen and (max-width: 900px) {
      height: 85vh;
      clip-path: polygon(0 0, 53% 0, 100% 100%, 16% 100%, 0 81%);
      width: 95%;
    }
    @media screen and (max-width: 480px) {
      height: 80vh;
      clip-path: polygon(0 0, 75% 0, 100% 100%, 0% 100%);
      width: 100%;
    }
  }
  .shapeTextContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 5%;
    text-justify: auto;
    font-weight: 600;
  }
  .shapeText {
    color: ${palette.white};
    font-size: 3.25rem;
    width: 27.5%;
    text-align: start;
    margin: 0px 20% 0% 7.5%;
    font-weight: 700;
    @media screen and (max-width: 700px) {
      font-size: 2.2rem;
    }
  }
  .shapeSubText {
    color: ${palette.white};
    font-size: 1.6rem;
    width: 42.5%;
    text-align: start;
    margin: 25px auto;
    font-weight: 600;
    @media screen and (max-width: 700px) {
      font-size: 1.8rem;
    }
  }
  .createAccountButton {
    background-color: ${palette.white};
    color: ${palette.black};
    padding: 5px 18px;
    border-radius: 4px;
    font-size: 1.1rem;
    margin: 25px auto 25px 35%;
    @media screen and (max-width: 700px) {
      font-size: 1.8rem;
    }
  }
  .signupContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 5% auto;
    justify-content: center;
    align-items: center;
    background-color: transparent;
  }
  .blackText {
    font-size: 2rem;
    font-weight: 700;
    width: auto;
    margin: 25px auto;
    color: ${palette.black};
  }
  .shineText {
    font-size: 2.2rem;
    font-weight: 800;
    width: auto;
    color: ${palette.black};
    margin: 30px auto;
    text-shadow: -4px 15px 15px #ffe000;
  }
  .createAccountButtonColor {
    background-color: ${palette.white};
    color: ${palette.white};
    padding: 7px 25px;
    border-radius: 4px;
    font-size: 1.4rem;
    margin: 35px auto;
    font-weight: 600;
    @media screen and (max-width: 700px) {
      font-size: 1.3rem;
    }
  }
  .mediumSection {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
    justify-content: center;
    align-items: center;
  }
  .imageRow {
    width: 100%;
    padding: 0px;
    margin: 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    position: relative;
    margin-bottom: 10%;
    background-color: ${palette.lightBS};
  }
  .defaultImageRow {
    width: 55%;
    height: auto;
    @media screen and (max-width: 720px) {
      width: 100%;
    }
    @media screen and (max-width: 900px) {
      width: 85%;
    }
  }
  .rowTextContainer {
    width: 45%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
    @media screen and (max-width: 720px) {
      width: 100%;
    }
    @media screen and (max-width: 900px) {
      width: 85%;
    }
  }
  .companiesSignupButton {
    color: ${palette.white};
    padding: 7px 25px;
    border-radius: 4px;
    font-size: 1.6rem;
    margin: 35px auto;
    font-weight: 600;
    @media screen and (max-width: 700px) {
      font-size: 1.3rem;
    }
  }
  .rowColorTitle {
    font-size: 1.9rem;
    margin-top: 20px;
  }
  .rowTitle {
    font-size: 2.6rem;
    color: ${palette.black};
  }
  .rowText {
    font-size: 1.8rem;
    width: 50%;
    @media screen and (max-width: 720px) {
      width: 100%;
      text-align: center;
    }
  }
  .secondDefaultImageRow {
    width: 35%;
    height: auto;
    display: none;
    @media screen and (max-width: 720px) {
      width: 100%;
      display: block;
    }
    @media screen and (max-width: 900px) {
      width: 85%;
      display: block;
    }
  }
  .secondRowTextContainer {
    width: 55%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (max-width: 720px) {
      width: 100%;
    }
    @media screen and (max-width: 900px) {
      width: 85%;
    }
  }
  .floatingTriangle {
    width: 30%;
    height: 33%;
    clip-path: polygon(76% 0, 0 0, 0 100%);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 40%;
    z-index: 2;
    @media screen and (max-width: 900px) {
      top: 22.5%;
      height: 17.5%;
    }
    @media screen and (max-width: 720px) {
      top: 25%;
      height: 10%;
    }
  }
  .cardsSection {
    width: 100%;
    display: flex;
    margin: 70px auto;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: column;
    @media screen and (max-width: 720px) {
      margin: 30px auto;
    }
  }
  .cardsContainer {
    width: 80%;
    display: flex;
    margin: 30px auto;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 720px) {
      width: 100%;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
  .companiesLogos {
    width: 60%;
    display: flex;
    margin: 40px auto;
    align-items: center;
    justify-content: space-around;
    padding: 10px;
    @media screen and (max-width: 720px) {
      width: 100%;
      padding: 10px;
      flex-wrap: wrap;
      margin: 70px auto;
    }
    @media screen and (max-width: 900px) {
      width: 90%;
    }
  }
  .homeCard {
    width: 47.5%;
    @media screen and (max-width: 720px) {
      width: 95%;
      margin-bottom: 20px;
    }
  }
  .cardContent {
    display: flex;
    width: 100%;
  }
  .cover {
    width: 40%;
    display: block;
    clip-path: polygon(0 0, 75% 0, 100% 100%, 0% 100%);
    @media screen and (max-width: 720px) {
      width: 100%;
      height: 185px;
    }
  }
  .content {
    display: flex;
    width: 60%;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    padding: 8px;
    @media screen and (max-width: 720px) {
      width: 100%;
    }
  }
  .moreDetails {
    display: flex;
    justify-content: space-around;
    width: 100%;
    align-items: center;
  }
  .cardTitle {
    font-size: 2.2rem;
    margin-left: -15px;
    margin-bottom: 14px;
    @media screen and (max-width: 720px) {
      font-size: 1.9rem;
      margin-bottom: 7px;
    }
  }
  .cardLink {
    font-size: 1.7rem;
    margin-left: 5px;
    margin-bottom: 5px;
    @media screen and (max-width: 720px) {
      font-size: 1.5rem;
    }
  }
  .cardText {
    font-size: 1.7rem;
    margin-left: 15px;
    margin-bottom: 8px;
    @media screen and (max-width: 720px) {
      font-size: 1.5rem;
    }
  }
  .companyLogo {
    width: 90px;
    height: auto;
    filter: grayscale(1);
    &:hover {
      filter: grayscale(0.2);
      transition: 1.5s;
    }
    @media screen and (max-width: 720px) {
      width: 85px;
      height: auto;
      margin: 10px;
    }
  }
  .rowInvertContainer {
    width: 100%;
    display: none;
    align-items: center;
  }
  .secondDefaultImageRowTablet {
    display: block;
    width: 45%;
    @media screen and (max-width: 900px) {
      display: none;
    }
    @media screen and (max-width: 700px) {
      display: none;
    }
  }
  .editionButtonContainer {
    width: 100%;
    background-color: ${palette.white};
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    padding: 10px;
    border-radius: 8px;
  }
  .editButton {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .editIcon {
    color: #aeaec1;
    font-size: 2.4rem;
  }
  .editText {
    color: #aeaec1;
    font-size: 1.2rem !important;
  }
  .editorContainer {
    width: 27.5%;
    position: absolute;
    background-color: ${palette.white};
    overflow: auto;
    box-shadow: 0 1.1px 4.6px -20px rgba(0, 0, 0, 0.018), 0 2.6px 10.8px -20px rgba(0, 0, 0, 0.026),
      0 4.7px 19.4px -20px rgba(0, 0, 0, 0.032), 0 7.9px 32.1px -20px rgba(0, 0, 0, 0.038),
      0 13px 52.9px -20px rgba(0, 0, 0, 0.044), 0 22.7px 92.5px -20px rgba(0, 0, 0, 0.052),
      0 49px 200px -20px rgba(0, 0, 0, 0.07);
    border-radius: 8px;
    z-index: 9999;
  }
  .paperContainer {
    background-color: ${palette.white};
    width: 100%;
  }
  .editorNavTitle {
    width: 100%;
    padding: 16px;
    margin: 0px;
    position: sticky;
    top: 0px;
    background-color: rgb(83, 115, 252);
    color: ${palette.white};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .editorNavTabs {
    width: 100%;
    padding: 0px;
    margin: 0px;
    position: sticky;
    height: 40px;
    display: flex;
    background-color: rgb(83, 115, 252);
    color: ${palette.white};
  }
  .editorTitle {
    font-size: 1.4rem !important;
    text-align: start;
    padding: 0px;
    margin: 0px;
  }
  .editorVersion {
    font-size: 1rem !important;
    text-align: start;
    padding: 0px;
    margin: 0px;
  }
  .editorTab {
    font-size: 1.4rem !important;
    text-align: center;
    padding: 0px;
    margin: 0px;
    width: 25%;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .editorTabActive {
    background-color: #91a5fd;
    font-size: 1.4rem !important;
    text-align: center;
    padding: 0px;
    margin: 0px;
    height: 100%;
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .editorChildContainer {
    background-color: ${palette.white};
    width: 100%;
    height: 420px;
    overflow: auto;
  }
  .accordionTitle {
    font-size: 1.2rem !important;
    text-align: start;
    padding: 0px;
    margin: 0px;
  }
  .editorButtonsOptions {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    position: sticky;
  }
  .editorButtonCancel {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${palette.white};
    background-color: #f7565d;
    margin: 0;
    cursor: pointer;
  }
  .editorButtonSave {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${palette.white};
    background-color: #5373fc;
    margin: 0px;
    cursor: pointer;
  }
  .accordionArea {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .accordionCard {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-direction: column;
  }
  .accordionLabel {
    font-size: 1.25rem !important;
    text-align: start;
    margin-bottom: 4px;
    color: ${palette.white};
  }
  .editIamge {
    width: 100%;
    height: 150px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    color: ${palette.white};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .inputBox100 {
    width: 100%;
    padding: 0px;
    margin: 0px;
  }
  .inputLabel {
    font-size: 1.1rem !important;
    font-weight: 400;
    margin-top: 10px;
  }
  .signupInput100 {
    width: 100%;
    margin: auto !important;
    background-color: #eef2f8;
    border: none !important;
    padding: 6px 4px !important;
    font-size: 1.3rem !important;
    color: ${palette.black};
  }
  .subjectInput {
    width: 100%;
    margin: auto !important;
    background-color: #eef2f8;
    border: none !important;
    padding: 6px 6px !important;
    font-size: 1.4rem !important;
    color: ${palette.black};
    border-radius: 8px;
  }
  .signupSelect100 {
    width: 100%;
    margin: auto !important;
    background-color: #eef2f8;
    border: none !important;
    padding: 6px 4px !important;
    font-size: 1.3rem !important;
    color: ${palette.black};
    resize: none;
  }
  .width100 {
    width: 100%;
    margin: 0px;
    padding: 0px;
  }
  .lightTextCenter {
    font-size: 1.9rem;
    font-weight: 400;
    width: 30%;
    margin: 25px auto;
    color: ${palette.black};
    @media screen and (max-width: 720px) {
      width: 65%;
    }
  }
  .campusContainer {
    width: 90%;
    margin-top: 25px;
    display: flex;
    padding: 0px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    font-family: 'Cooper Md BT', sans-serif;
  }
  .mailingContainer {
    width: 90%;
    margin-top: 25px;
    display: flex;
    padding: 0px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
  }
  .mailOptions {
    width: 100%;
    display: flex;
    margin: 5px auto;
  }
  .mailNavBar {
    width: 95%;
    display: flex;
    padding: 32px;
    align-items: center;
    justify-content: space-between;
    background-color: ${palette.white};
    box-shadow: 0px 2px 30px #00000029;
    flex-direction: column;
    border-radius: 8px;
  }
  .mailButtonContainer {
    width: 95%;
    display: flex;
    padding: 16px 32px;
    align-items: flex-end;
    justify-content: flex-end;
    background-color: ${palette.white};
    box-shadow: 0px 2px 30px #00000029;
    margin: 0px 0px 50px 0px;
    border-radius: 8px;
  }
  .mailPage {
    width: 95%;
    margin: 40px 0px 20px 0px;
    display: flex;
    padding: 32px;
    align-items: flex-start;
    justify-content: space-between;
    background-color: ${palette.white};
    box-shadow: 0px 2px 30px #00000029;
    border-radius: 8px;
  }
  .mailNavItemActive {
    width: 100%;
    padding: 14px 0px;
    font-size: 1.6rem;
    text-align: center;
    margin: 0px;
    background-color: rgba(83, 115, 252, 0.2);
    color: #5373fc;
    cursor: pointer;
    height: 55px;
    font-weight: 500;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mailNavItem {
    width: 100%;
    padding: 14px 0px;
    font-size: 1.6rem;
    color: ${palette.black};
    text-align: center;
    margin: 0px;
    cursor: pointer;
    height: 55px;
    font-weight: 500;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mailTools {
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 15px;
    height: 100%;
    left: 0;
  }
  .mailBody {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    flex-direction: column;
    overflow: auto;
    flex-wrap: wrap;
  }
  .mailButton {
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    flex-direction: column;
    margin: 20px auto;
    padding: 10px 0px;
    color: #aeaec1 !important;
    &:hover {
      color: black !important;
    }
  }
  .mailLabel {
    font-size: 1.4rem !important;
    padding: 0px;
    margin: 5px auto;
    text-align: center;
  }
  .mailIcon {
    font-size: 3rem !important;
    margin: auto;
  }
  .mailDestinyButton {
    font-size: 1.8rem;
    font-weight: 500;
    padding: 6px 60px;
    margin-left: auto;
    background-color: #5373fc;
    color: ${palette.white};
  }
  .confirmSendEmail {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
  }
  .confirmButtonContainer {
    width: 40%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 2px 30px #00000029;
    border-radius: 4px;
    background-color: ${palette.white};
  }
  .confirmText {
    width: 100%;
    font-size: 2rem !important;
  }
  .sendButtons {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
  .buttonCancel {
    padding: 6px 32px;
    font-size: 1.8rem !important;
    color: ${palette.white};
    background-color: ${palette.red};
  }
  .buttonSend {
    padding: 6px 32px;
    font-size: 1.8rem !important;
    color: ${palette.white};
    background-color: #0f3f44;
  }
  .listItemCampus {
    border: 2px solid #f0f1f8;
    border-radius: 4px;
    background-color: #ffffff;
    padding: 15px 32px;
    margin-bottom: 16px;
  }
  .listText {
    font-size: 1.2rem !important;
    color: #0f3f44;
    font-family: 'Cooper Md BT', sans-serif !important;
    margin: 4px 0px;
  }
  .backdrop {
    z-index: 1;
    color: #fff;
  }
  .interfaceOptions {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px;
    flex-direction: column;
  }
  .optionSelected1 {
    width: 100%;
    height: 185px;
    background: linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35));
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px auto;
  }
  .optionAvailable1 {
    width: 100%;
    height: 185px;
    margin: 12px auto;
    cursor: pointer;
  }
  .optionSelected2 {
    width: 100%;
    height: 185px;
    display: flex;
    justify-content: center;
    margin: 12px auto;
    align-items: center;
  }
  .optionAvailable2 {
    width: 100%;
    height: 185px;
    margin: 12px auto;
    cursor: pointer;
  }
  .optionSelectedIcon {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    flex-direction: column;
  }
  .inputLink {
    width: 100%;
    padding: 6px;
    border-radius: 6px;
    color: ${palette.black};
    font-size: 1.3rem;
    border: solid 2px lightgray;
    margin: 10px auto;
  }
`;

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: palette.blue,
    backgroundColor: palette.blue,
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  circle: {
    color: '#eaeaf0',
    zIndex: 1,
    fontSize: 18,
  },
  completed: {
    color: palette.blue,
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}>
      {completed ? (
        <RadioButtonCheckedIcon className={classes.completed} />
      ) : (
        <RadioButtonUncheckedIcon className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

QontoStepIcon.defaultProps = {
  active: false,
  completed: false,
};

const MainDashboard = () => {
  const [state, setState] = useState({
    activeStep: 0,
  });
  const platform = useSelector((state) => state.platform);
  const dispatch = useDispatch();

  const changeStep = (value) => {
    setState((prevState) => ({
      ...prevState,
      activeStep: value,
    }));
  };

  const updatePlatform = async (data) => {
    const prevPage = state.activeStep;
    await dispatch(newUpdatePlatform(data));
    ShowNotification('success', 'Se completo de manera correcta', '¡Listo!');
    setState((prevState) => ({
      ...prevState,
      activeStep: prevPage,
    }));
  };

  const getContent = (i) => {
    if (platform.platformName == 'utel') {
      switch (i) {
        case 0:
          return <GeneralSettings />;
        case 1:
          return <CampusSettings update={updatePlatform} />;
        case 2:
          return <Mailing />;
        // case 'help':
        //   return <HelpSection />;
        default:
          return <p>Unknow error please reload page to continue</p>;
      }
    } else {
      switch (i) {
        case 0:
          return <GeneralSettings />;
        case 1:
          return <VisualSettings />;
        case 2:
          return <CampusSettings update={updatePlatform} />;
        case 3:
          return <Mailing />;
        // case 'help':
        //   return <HelpSection />;
        default:
          return <p>Unknow error please reload page to continue</p>;
      }
    }
  };
  const getSteep =
    platform.platformName == 'utel' ? ['General', 'Campus', 'Mailing'] : ['General', 'Visual', 'Campus', 'Mailing'];

  return (
    <MainContainer>
      <Grid container spacing={2}>
        <Grid item lg={3}>
          <div className="leftStepper">
            <p className="stepperTitle">Administración</p>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fstep3.png?alt=media&token=1c3106ce-e6cd-47aa-b361-1dc4f5b15ca6"
              alt="Intituciones LaPieza"
              className="stepImage"
            />
            <div className="stepper">
              <Stepper
                activeStep={state.activeStep}
                orientation="vertical"
                style={{
                  background: 'transparent',
                }}>
                {getSteep?.map((steep, idx) => (
                  <Step key={steep}>
                    <StepLabel
                      StepIconComponent={QontoStepIcon}
                      style={{ cursor: 'pointer' }}
                      onClick={() => changeStep(idx)}>
                      {steep}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
          </div>
        </Grid>

        <Grid item lg={9}>
          <div className="mainContainer">{getContent(state.activeStep)}</div>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default MainDashboard;
